import {
  Card,
  CardTitle,
  CardHeader,
  CardDescription,
} from '@design-system/Card';

import { cn } from '@/utils/styles';
import { Skeleton } from '@design-system/Skeleton';

type ISectionData = {
  label: string;
  value?: string | number;
};

export interface SampleDetailsPageSectionProps
  extends Omit<React.ComponentProps<'div'>, 'title'> {
  isLoading?: boolean;
  data: ISectionData[];
  title: React.ReactNode;
}

const renderSectionData = (
  sectionData: ISectionData[],
  isLoading?: boolean,
) => {
  const renderedSectionData = sectionData.map((data) => (
    <li key={data.label}>
      <Card>
        <CardHeader>
          <CardTitle className="typography-btn-large text-tertiary">
            {data.label}
          </CardTitle>

          <CardDescription className="typography-btn-large text-primary">
            {isLoading ? (
              <Skeleton className="w-full h-4 max-w-52" />
            ) : (
              <span className="truncate">
                <abbr title={String(data.value)} className="no-underline">
                  {data.value}
                </abbr>
              </span>
            )}
          </CardDescription>
        </CardHeader>
      </Card>
    </li>
  ));

  return renderedSectionData;
};

export const SampleDetailsPageSection = ({
  data,
  title,
  isLoading,
  className,
  ...rest
}: SampleDetailsPageSectionProps) => {
  return (
    <div {...rest} className={cn('flex flex-col', className)}>
      <span className="typography-h2 text-primary mb-6">{title}</span>

      <ul className="flex flex-col gap-2">
        {renderSectionData(data, isLoading)}
      </ul>
    </div>
  );
};
